<template>
  <DashboardLayout class="employee">
    <div class="client-listing__heading">
      <AppHeading tag="h2" text="Listado de clientes" />
      <AppCounter :total="clientListing.length" />
    </div>

    <div class="client-listing__actions">
      <SearchBar label="Búsqueda por nombre" v-model="searchQuery" />
    </div>

    <div class="client-listing__table">
      <DataTable :headers="tableConfig" :items="filteredElements">
        <template #table-item="{ currentRow, currentOption }">
          <!-- Name -->
          <AppRouterLink
            v-if="currentOption.value === 'name'"
            :text="currentRow[currentOption.value]"
            :to="{ name: 'dashboard-client', params: { account_id: currentRow.id } }"
          />

          <!-- Suscription name -->
          <span v-if="currentOption.value === 'pack_name'">
            {{ currentRow[currentOption.value] }}
          </span>

          <!-- Suscription end date -->
          <span v-if="currentOption.value === 'pack_end_date'">
            {{ getFormatedDate(currentRow[currentOption.value]) }}
          </span>

          <!-- Language -->
          <span v-if="currentOption.value === 'language'">
            {{ currentRow[currentOption.value].toUpperCase() }}
          </span>
        </template>

        <!-- FOOTER -->
        <template #table-add-ons>
          <transition name="scale-in">
            <SearchNoResults v-if="SearchNoResults" :query="searchQuery" />
          </transition>
        </template>
      </DataTable>
    </div>
  </DashboardLayout>
</template>

<script>
// Utilities
import { formatDate, filterElementsByQuery } from 'Utils'
// Components
import AppCounter from 'Ui/AppCounter'
import SearchBar from 'Ui/SearchBar'
import AppHeading from 'Ui/AppHeading'
import AppRouterLink from 'Ui/AppRouterLink'
import DataTable from 'Components/DataTable'
import DashboardLayout from 'Layouts/DashboardLayout'
import SearchNoResults from 'Components/SearchNoResults'

export default {
  name: 'DashboardTeamClientListing',

  components: {
    DataTable,
    SearchBar,
    AppHeading,
    AppCounter,
    AppRouterLink,
    DashboardLayout,
    SearchNoResults,
  },

  data() {
    return {
      clientListing: null,
      searchQuery: '',
      tableConfig: [
        { text: 'Nombre', value: 'name', sortable: true },
        { text: 'Suscripción', value: 'pack_name', sortable: true },
        { text: 'Vencimiento', value: 'pack_end_date', sortable: true },
        { text: 'Idioma', value: 'language', sortable: true },
      ],
    }
  },

  computed: {
    getFormatedDate() {
      return (date) => {
        const formatedDate = formatDate(date)

        if (formatedDate == 'Invalid Date') return 'No end date'
        return formatDate(date)
      }
    },

    filteredElements() {
      return filterElementsByQuery(this.searchQuery, this.clientListing, 'name')
    },

    SearchNoResults() {
      return this.filteredElements.length === 0
    },
  },

  created() {
    this.clientListing = this.$store.getters['clients/getClients']
  },
}
</script>

<style scoped>
.client-listing__heading {
  display: flex;
  align-items: center;
  gap: 10px;
}

.client-listing__heading .app-heading {
  font-weight: 900;
}

.client-listing__actions {
  display: inline-block;
  margin: 20px 0;
}

.data-table__body-col--name .app-link {
  font-weight: 600;
}
</style>
